import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import UserLogin from "../mutations/Login";
import CurrentUser from "../queries/CurrentUser";
import CurrentUserData from "../queries/CurrentUserData";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupText,
  InputGroup,
  Col,
} from "reactstrap";
// icons

const Login = () => {
  const [user_name, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState([]);

  const [loginUser] = useMutation(UserLogin);

  const handleMutation = (variables) => {
    loginUser({
      variables,
      refetchQueries: [{ query: CurrentUserData }, { query: CurrentUser }],
    })
      .then((result) => console.log("login result: ", result))
      .catch((error) => {
        const resultString = error.message
          .substring(error.message.indexOf(":") + 2)
          .trim()
          .replace(/"/g, "");

        setErrors([resultString]);
      });
  };

  function onSubmit(e) {
    e.preventDefault();

    const variables = {
      user_name: user_name,
      password: password,
    };
    handleMutation(variables);

    setUserName("");
    setPassword("");
    setErrors([]);
  }

  const displayErrors = () => {
    console.log("errors: ", errors);
    if (errors.length > 0) {
      return errors[0];
    }
  };

  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent font-weight-bold">
            Please sign in
          </CardHeader>
          <CardBody className="px-lg-5 py-lg-5">
            <Form onSubmit={onSubmit}>
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupText>
                    <span className="material-symbols-outlined">person</span>
                  </InputGroupText>
                  <Input
                    placeholder="User Name"
                    type="text"
                    value={user_name}
                    onChange={(evt) => setUserName(evt.target.value)}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupText>
                    <span className="material-symbols-outlined">lock_open</span>
                  </InputGroupText>
                  <Input
                    placeholder="Password"
                    type="password"
                    value={password}
                    onChange={(evt) => setPassword(evt.target.value)}
                  />
                </InputGroup>
              </FormGroup>
              <div className="text-center">
                <div className="login-error text-danger">{displayErrors()}</div>

                <Button className="mt-auto" color="primary" type="submit">
                  Sign in
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default Login;
